export const DEFAULT_MAX_HEIGHT = 51;
